module.exports = __webpack_public_path__ + "img/eduDP.2faa76ec.svg";